import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import _ from 'lodash';

import { Paper, Switch, Button, Dropdown, Animation, TextField  } from 'components'
import { AnimatePresence } from "framer-motion"
import { FaLock, FaLink } from 'react-icons/fa'

import * as actionCreators from 'store/actions'
import UserBlock from './UserBlock';

const Container = styled.div`
    border-radius: 5px;
    background-color: var(--secondary-color);
    min-width: 25rem;
    padding: 0.5rem 1rem;
    overflow: hidden;
`

const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin: 0.5rem 0;
    cursor: pointer;
`

const Title = styled.div`
    font-weight: bolder;
`

const Subtitle = styled.div`
    font-size: 0.9rem;
`

const LinkContainer = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    margin: 0.5rem 0;
    border-radius: 5px;
    border: ${props => `1px solid ${props.copy ? 'var(--focus-color)' : 'var(--secondary-color)'}`};
    background-color: ${props => props.copy ? 'var(--focus-color)' : 'var(--secondary-color)'};
`

const Link = styled.div`
    cursor: pointer;
    overflow: hidden;
    background-color: var(--primary-color);
    border-radius: 5px 0 0 5px;
    padding: 0.5rem 1rem;
    flex-grow: 4;
`

const InviteContainer = styled.div`
    display: flex;
    margin-top: 0.5rem; 
`

const AccessContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 0 0 0.5rem 0;
`

const UsersContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    border-radius: 5px;
    background-color: var(--primary-color);
    min-height: 5rem;
    max-height: 20rem;
    overflow-y: auto;
`

const Wrapper = styled.div`
    background-color: var(--primary-color);
    padding: 0.5rem;
    margin: 0.5rem 0;
    border-radius: 5px;
`

const Error = styled.div`
    font-size: 0.9rem;
    color: var(--error-color);
    margin: 0.25rem;
`

class ShareOptions extends Component {
    constructor(props){
        super(props);
        this.state = {
            share: false,
            shareType: null,
            link: 'www.youtube.com',
            copy: false,
            users: {},
            error: null,
            user: {
                uid: uuidv4(),
                email: null, 
                access: 'VIEW'
            },

        }

        this.defaultUser = {
            uid: uuidv4(),
            email: this.props.user.email, 
            access: 'OWNER'
        }

        this.buttonStyle = {
            backgroundColor: 'var(--focus-color)',
            margin: 0,
            width: '3rem',
            borderRadius: '0 5px 5px 0',
            padding: '0.5rem',
            color: 'white'
         }

        this.shareTypes = {
            RESTRICTED: 'Only invited users can access',
            ANYONE_VIEW: 'Anyone with the link can view',
            ANYONE_EDIT: 'Anyone with the link can edit'
        }
    }

    copyHandler = () => {
        this.setState({
            copy: !this.state.copy
        }, () => setTimeout(() => {
            this.setState({
                copy: !this.state.copy
            })
        }, 1000))
    }

    removeUserHandler = (uid) => {
        let updatedUsers = {...this.state.users}
        delete updatedUsers[uid]
        this.setState({users: updatedUsers})
    }

    editUserHandler = (uid, access) => {
        let updatedUsers = {...this.state.users}
        if(access !== 'REMOVE'){
            updatedUsers[uid]['access'] = access
            this.setState({users: updatedUsers})
        } else {
            delete updatedUsers[uid]
            this.setState({users: updatedUsers})
        }
        
    }

    addUserHandler = () => {
        let updatedUsers = {...this.state.users}
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if(!this.state.user['email']){
            this.setState({error: 'Please enter a valid email'})
        } else if(!re.test(this.state.user['email'])){
            this.setState({error: 'Please enter a valid email'})
        } else if (_.filter(Object.values(this.state.users), (user) => user['email'] === this.state.user['email']).length > 0) {
            this.setState({error: 'User has been added already'})
        } else {
            updatedUsers[this.state.user['uid']] = this.state.user
            this.setState({
                users: updatedUsers,
                error: null,
                user: {
                    uid: uuidv4(),
                    email: '',
                    access: 'VIEW'
                }
            })
        }
        
    }

    editEmailHandler = (event) => {
        let updatedUser = {...this.state.user}
        updatedUser['email'] = event.target.value
        this.setState({user: updatedUser})
    }

    onKeyPressHandler = (event) => {
        if (event.charCode === 13) {
            this.addUserHandler();
        } 
    }

    render() {
        console.log('ShareOptions', this.state)
        let userBlocks = [] ;
        if(this.state.shareType === 'RESTRICTED'){
            userBlocks.push(<UserBlock user={this.defaultUser}/>)
            if(Object.keys(this.state.users).length > 0){
                for (const [id, user] of Object.entries(this.state.users)) {
                    userBlocks.push(<UserBlock user={user} key={user['uid']}
                        onChange={this.editUserHandler}
                        onRemove={this.removeUserHandler}/>)
                }
            } else {
                userBlocks.push(<div style={{fontSize: '0.9rem', padding: '0.5rem 0.5rem 0 0.5rem',flexGrow: 4, display: 'flex', alignItems: 'center'}}>No collaborators yet</div>)
            }
            
        } 
        
        return (
            <Paper>
                <Container>
                    <Header onClick={() => this.setState({share: !this.state.share, shareType: 'RESTRICTED'})}>
                        <div style={{marginLeft: '0.25rem'}}>
                            <Title>Share</Title>
                            <Subtitle>Allow others to view/edit this page</Subtitle>
                        </div>
                        <Switch checked={this.state.share} onChange={() => this.setState({share: !this.state.share, shareType: 'RESTRICTED'})}/>
                    </Header>

                    {/* Link container */}
                    <AnimatePresence initial={false}>
                        {this.state.share && 
                        <Animation animation='expand'>
                            <LinkContainer onClick={this.copyHandler} copy={this.state.copy}>
                                <Link>{this.state.link}</Link>
                                <Button text={this.state.copy ? 'Copied!' : 'Copy'} styles={this.buttonStyle}/>
                            </LinkContainer>
                            <div style={{display: 'flex', alignItems: 'center', fontSize: '0.9rem', margin: '0 0.5rem'}}>
                                {this.state.shareType === 'RESTRICTED' ? <FaLock/> : <FaLink/>}
                                <Dropdown style={{width: 'fit-content', padding: '0.5rem', backgroundColor: 'var(--secondary-color)', borderColor: 'transparent', fontSize:'0.8rem', margin:'0 0.5rem'}}
                                    value={this.shareTypes[this.state.shareType]} 
                                    options={this.shareTypes} 
                                    onSelect={(value) => this.setState({shareType: value})}/>
                            </div>
                        </Animation>}
                    </AnimatePresence>
                    
                    {/* Access controls */}
                    <AnimatePresence initial={false}>
                        {this.state.shareType === 'RESTRICTED' & this.state.share &&
                        <Animation animation='expand'>
                            <AccessContainer>

                                <Wrapper>
                                    <UsersContainer>
                                        {userBlocks}
                                    </UsersContainer>
                                </Wrapper>

                                <InviteContainer>
                                    <TextField type='single' value={this.state.user['email']} mantainFocus={true} focus
                                        style={{backgroundColor: 'var(--primary-color)', borderRadius: '5px 0 0 5px', padding: '0.5rem 1rem'}}
                                        onChange={this.editEmailHandler} 
                                        onKeyPress={this.onKeyPressHandler}/>
                                    <Button text='Invite' onSelect={this.addUserHandler} styles={this.buttonStyle}/>
                                </InviteContainer>
                                <Error>{this.state.error}</Error>
                            </AccessContainer>
                        </Animation>}
                    </AnimatePresence>
                    
                </Container>
            </Paper>
                
        )
    }
}

const mapStateToProps = state => {
    return {
        user: state.auth.user
    }
};

const mapDispatchToProps = dispatch => {
    return {
        
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ShareOptions);